import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>How to maintain momentum
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to maintain momentum.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>You may or may not have experienced the phenomenon known as
                                                hitting the wall, synonymous
                                                with the last few miles of a marathon...</p>


                                            <div className="border_subtitle">Hitting the wall</div>
                                            <div className="paraspace"><p>When people hit the wall they describe
                                                feelings of fatigue, shifting focus or unintentional changes
                                                in pace. This phenomenon can partly be explained through
                                                physiological perspectives.<a className="superscripttext"
                                                                              href="further_info.php?course=300"><sup>1</sup></a> Depleted
                                                glycogen supplies means the body converts fat into energy, which
                                                is slower and less efficient
                                                than normal. But there is a far more psychological element to
                                                overcoming this barrier, as by using
                                                our mind, we can dictate how long we are able to keep going.</p>
                                            </div>


                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">Anticipate the finish</div>
                                                <p>Ulmer and colleagues devised a theory that we tend to
                                                    anticipate where the
                                                    finish point is and work backwards to regulate the effort
                                                    required – known as ‘teleoanticipation’.<a
                                                        className="superscripttext"
                                                        href="further_info.php?course=300"><sup>2</sup></a>
                                                </p>
                                                <p>In this way we moderate intensity and effort to complete the
                                                    task. Researchers carried out
                                                    a study to investigate this and found that runners who were
                                                    told that they had 30 minutes
                                                    to run but actually ran for 20 were less exhausted than
                                                    those who were told that they had
                                                    20 minutes to run. The implications are that we are
                                                    subjective about how fatigued we get
                                                    and can therefore control this by setting realistic
                                                    expectations.</p>
                                                <p>Further research into psychological momentum<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>3</sup></a> has
                                                    shown that success breeds success.
                                                    Students were told that a basketball team had just beaten
                                                    another in a local derby. The
                                                    students rated that team as more likely to win the next game
                                                    based on this information.
                                                    This is commonly known as ‘being on a roll’.
                                                </p>
                                                <div className="uiheading"><p>There is however a caveat; in
                                                    another study, participants were told that an author had
                                                    been
                                                    working on a research paper but was then interrupted. Some
                                                    were told that she was ‘on a
                                                    roll’, others that she was working steadily. The
                                                    participants rated her chances of completing
                                                    the work as higher if she had been working at a steady pace.
                                                    This implies that once on a
                                                    roll, momentum is easier to lose than if working
                                                    steadily.</p></div>


                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}